import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAuth } from "../context/auth";
import authHeader from "../services/auth.header";
import axios from "axios";
import { useForm } from "react-hook-form";
import Popup from "reactjs-popup";
import AddressPrompt from "../components/prompts/AddressPrompt";
const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const Header = styled.h1`
  margin-top: 20px;
  margin-left: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
`;

const FormLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
`;

const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

const SelectInput = styled.select`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
  option {
    color: #fffcf2;
    background: #2f2323;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`;

const AddInput = styled.textarea`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  height: auto;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
  overflow: hidden;
`;

const NextBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

const StyledPopup = styled(Popup)`
  &-overlay {
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: rgba(4, 3, 3, 0.7);
  }
  &-content {
    position: absolute;
    color: #fdfffc;
    top: auto !important;
    bottom: 0px !important;
    overflow: auto;
    height: 100%;
    right: auto;
    width: 100%;
    left: 0px !important;
    border-radius: 20px;
    outline: none;
    padding-bottom: 10px;
    background-color: #040303;
    padding: 5px;
  }
`;
export default function Address(props) {
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryName, setCountryName] = useState("");
  const [state, setState] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [stateName, setStateName] = useState("");
  const [city, setCity] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [dataProps, setDataProps] = useState({
    address: "",
    zipCode: "",
    state: "",
    country: "",
    city: "",
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setState("");
    setCity("");
    getCountries();
  }, []);

  const getCountries = () => {
    return axios
      .get(" https://api.countrystatecity.in/v1/countries", {
        headers: {
          "X-CSCAPI-KEY":
            "eHZMRjVYMzA3WjI3OFJKYm9TMnpNbUVrSVZ5NUVRQkE4U3NnNVB4bA==",
        },
      })
      .then((res) => {
        setCountry(res.data);
      });
  };

  useEffect(() => {
    getState();
  }, [selectedCountry]);

  useEffect(() => {
    getCity();
  }, [selectedState]);

  useEffect(() => {
    getAddress();
  }, []);

  const getAddress = () => {
    return axios
      .get(BASE_URL + "users/" + user.data.id + "/profile" + "/settings", {
        headers: authHeader(),
      })
      .then((response) => {
        reset({
          address: response.data.data.address.address,
          zipCode: response.data.data.address.zipCode,
          state: response.data.data.address.state,
          country: response.data.data.address.country,
        });
      });
  };

  const { user, setting } = useAuth();
  const BASE_URL = "https://catway.services.ombre.app/v1/";
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  console.log("selectedCountry", countryName);
  console.log("selected state", stateName);
  console.log("selected city", selectedCity);

  const getState = () => {
    if (selectedCountry) {
      return axios
        .get(
          `https://api.countrystatecity.in/v1/countries/${selectedCountry}/states`,
          {
            headers: {
              "X-CSCAPI-KEY":
                "eHZMRjVYMzA3WjI3OFJKYm9TMnpNbUVrSVZ5NUVRQkE4U3NnNVB4bA==",
            },
          }
        )
        .then((res) => {
          setState(res.data);
        });
    }
  };

  const getCity = () => {
    if (selectedState) {
      return axios
        .get(
          `https://api.countrystatecity.in/v1/countries/${selectedCountry}/states/${selectedState}/cities`,
          {
            headers: {
              "X-CSCAPI-KEY":
                "eHZMRjVYMzA3WjI3OFJKYm9TMnpNbUVrSVZ5NUVRQkE4U3NnNVB4bA==",
            },
          }
        )
        .then((res) => {
          setCity(res.data);
        });
    }
  };

  const onSubmit = (data) => {
    setDataProps({
      address: data.address,
      zipCode: data.zipCode,
      state: stateName,
      country: countryName,
      city: selectedCity,
    });
    setOpen(true);
  };

  return (
    <>
      <Header style={{ marginTop: "70px" }}>Change Address</Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className="mt-3">
            <FormLabel>Address:</FormLabel>
          </div>
          <div className="d-flex px-3">
            <AddInput {...register("address")} />
          </div>
          <div className="mt-3">
            <FormLabel>Zip Code:</FormLabel>
          </div>
          <div className="d-flex px-3">
            <FormInput {...register("zipCode")} />
          </div>

          <div className="mt-3">
            <FormLabel>Country:</FormLabel>
          </div>
          <div className="d-flex px-3">
            <FormInput style={{ display: "none" }} {...register("country")} />
          </div>
          <div className="d-flex px-3">
            <SelectInput
              onChange={(e) => {
                setSelectedCountry(e.target.value);
                setCountryName(e.target[e.target.selectedIndex].text);
              }}
            >
              {country.map((countries) => (
                <option key={countries.iso2} value={countries.iso2}>
                  {countries.name}
                </option>
              ))}
            </SelectInput>
          </div>
        </div>
        <div className="mt-3">
          <FormLabel>State:</FormLabel>
        </div>
        <div className="d-flex px-3">
          <FormInput style={{ display: "none" }} {...register("state")} />
        </div>
        <div className="d-flex px-3">
          <SelectInput
            onChange={(e) => {
              setSelectedState(e.target.value);
              setStateName(e.target[e.target.selectedIndex].text);
            }}
          >
            {state &&
              state.map((states) => (
                <option key={states.iso2} value={states.iso2}>
                  {states.name}
                </option>
              ))}
          </SelectInput>
        </div>
        <div className="mt-3">
          <FormLabel>City:</FormLabel>
        </div>
        <div className="d-flex px-3">
          <FormInput style={{ display: "none" }} {...register("city")} />
        </div>
        <div className="d-flex px-3">
          <SelectInput
            onChange={(e) => {
              setSelectedCity(e.target.value);
            }}
          >
            {city &&
              city.map((cities) => (
                <option key={cities.iso2} value={cities.iso2}>
                  {cities.name}
                </option>
              ))}
          </SelectInput>
        </div>
        <div style={{ marginTop: "20px", marginBottom: "30px" }}>
          <NextBtn type="submit">Update</NextBtn>
          <StyledPopup open={open} closeOnEscape arrow="false">
            <AddressPrompt address={dataProps} />
          </StyledPopup>
        </div>
      </form>
    </>
  );
}
